import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const InvoiceService = {
  getInvoice(code, params) {
    const requestScreenData = {
      url: "api/Invoice",
      filter: `Code eq ${code}`,
    };

    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return ApiService.oDataGet(requestScreenData);
  },
  getInvoiceDetails(code, params) {
    const requestScreenData = {
      url: "api/InvoiceDetail",
      filter: `InvoiceCode eq ${code}`,
      orderby: "LineNo asc",
    };

    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return ApiService.oDataGet(requestScreenData);

  },

  async getCustomDataSocurce(paramUrl, params) {
    const requestScreenData = {
      url: "api/" + paramUrl,
      filter: params.filter,
    };

    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }
    return await ApiService.oDataGet(requestScreenData);
  },

  async saveEditInvoice(payload) {
    var url = `api/Save_Invoice`;

    return await ApiService.post(url, payload);
  },
  async getCustomRequest(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },

  async getInvoiceBySalesOrder(code, params) {
    const requestScreenData = {
      url: "api/Invoice",
      filter: `SalesOrderCode eq '${code}'`,
      top: "1"
    };
    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);

  },

  async saveCreateInvoice(payload) {
    var url = `api/Save_DirectInvoice`;

    return await ApiService.post(url, payload);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
        url: "api/ActiveAccountingPeriod",
        top: "1",
        filter: `PeriodType eq 'AR'`,
        orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
},
async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
        url: "api/ActiveAccountingPeriod",
        top: "1",
        filter: `PeriodType eq 'AR'`,
        orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
},

};

export { InvoiceService };
